import BossModel from "@/models/BossModel";
import Dossier from '@/models/Dossier/Dossier'
import Identity from "@/models/Dossier/Passport/Identity/Identity";
import Version from "@/models/Customer/Traveller/Version/Version";

export default class Traveller extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/traveller';

    /**
     *
     * @type {string}
     */
    static entity = 'travellers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            customer_traveller_version_id: this.number(null),
            is_active: this.boolean(true),
            is_offer_receiver: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            identity: this.hasOne(Identity, 'dossier_traveller_id'),
            version: this.belongsTo(Version, 'customer_traveller_version_id'),
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    Deactivate() {
        return this.constructor.api()
            .action(this.id + '/active/0')
            .update(this);
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    Activate() {
        return this.constructor.api()
            .action(this.id + '/active/1')
            .update(this);
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId) {
        return this.api()
            .where('dossier_id', dossierId)
            .with('version')
            .limit(0)
            .get();
    }
}
